import style from './list-pager.scss';
import listPager from 'Assets/js/list-pager-behavior';

const script = () => {
  listPager({
    cssClass: '.ListPager',
    cssClassDefault: 'ListPager',
    cssClassItem: '.ListPager-item',
  });
  listPager({
    cssClass: '.view .pager',
    cssClassItem: '.view .pager .pager__item',
  });
};

export {
  style,
  script,
};
